import React from "react";
import { Link } from "react-router-dom";
import "./Web1920139.css";

function Web1920139(props) {
  const { overlapGroup1, visualization, backToImage } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-139 screen">
        <div className="overlap-group1-21" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-37 border-1px-dove-gray"></div>
          <div className="visualization-1">{visualization}</div>
          <Link to="/web-1920-136">
            <div className="group-142-13">
              <div className="overlap-group-45">
                <div className="rectangle-33-20 border-3px-picton-blue"></div>
                <div className="back-to-image-9 lato-medium-white-13px">{backToImage}</div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920139;
